/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Suggestion_ExplainInputs */



/**
* | output |
* | --- |
* | "What can you do?" |
*
* @param {Uno_Suggestion_ExplainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_suggestion_explain = /** @type {((inputs?: Uno_Suggestion_ExplainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Suggestion_ExplainInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was kannst du?")
	return /** @type {LocalizedString} */ ("What can you do?")
});